import { DataScienceEnums } from 'dashboard-services/api/dataScience';
import { ActionService } from 'dashboard-services/services';

import { isFileTypeSupportedForPreview } from 'components/modules/DataScience/PipelineCreator/Options/ValueTypeResolver/Header';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_DATA_VERIFICATION_MODAL_CREATOR_DATA_SCIENCE'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const CLEAN = 'CLEAN_DATA_VERIFICATION_MODAL_CREATOR_DATA_SCIENCE'
  const clean = ActionService.makeActionCreator(CLEAN)

  const validateParamMayBeEdited = ({ fileObject, param }) => ((fileObject !== undefined && param?.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.DATALAKE_FILE && isFileTypeSupportedForPreview(fileObject?.name ? String(fileObject?.name) : "")) || (Object.keys(param.port?.links || {}).length > 0 && (param?.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.STRING || param?.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.NUMBER  || param?.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.TEXT_AREA)))

  return {
    changeValue,
    clean,
    CHANGE_VALUE,
    CLEAN,
    validateParamMayBeEdited
  }
})()